import RaterPricing from '@/modules/common/common/models/MID/RaterPricing'

export default class RaterPriceResponse {
  /** (String): Identificador de la solicitud. Ejemplo: "63a075f1-f89b-4b86-8967-444baa63d30f". */
  quotationId!: string

  /** (Array): Listado de tarificaciones. */
  listPricing!: RaterPricing[]

  constructor(data: any) {
    this.quotationId = data.quotationId
    this.listPricing = data.listPricing?.map((pricingData: any) => new RaterPricing(pricingData))
  }
}
